import "i18n/config";

import { AppFailedQueryReset } from "app/AppFailedQueryReset";
import { AppLoadingIndicator } from "app/AppLoadingIndicator";
import { AppLoggedOutLayout } from "app/AppLoggedOutLayout";
import { AppRootErrorPage } from "app/AppRootErrorPage";
import { AppUpdatePrompt } from "app/AppUpdatePrompt";
import React from "react";
import { Outlet } from "react-router-dom";
import { QueryBoundary } from "shared/api/QueryBoundary";
import { LoadingState } from "shared/components/empty/LoadingState";
import Page from "shared/components/layout/Page";
import { ConfirmationDialogProvider } from "shared/components/modal/confirm/ConfirmationDialogContext";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";

const AppRoot: React.FC = () => (
  <QueryParamProvider
    adapter={ReactRouter6Adapter}
    options={{ removeDefaultsFromUrl: true, updateType: "replaceIn" }}
  >
    <QueryBoundary
      ErrorComponent={AppRootErrorPage}
      pendingFallback={<AppRootLoading />}
    >
      <ConfirmationDialogProvider>
        <Page>
          <AppUpdatePrompt />
          <AppLoadingIndicator />
          <Outlet />
        </Page>
      </ConfirmationDialogProvider>
      <AppFailedQueryReset />
    </QueryBoundary>
  </QueryParamProvider>
);

export default AppRoot;

const AppRootLoading: React.FC = () => (
  <Page>
    <AppLoggedOutLayout>
      <LoadingState />
    </AppLoggedOutLayout>
  </Page>
);
